import { T } from "@tolgee/react";
import { FC } from "react";

interface BomPageExplainerSectionDescriptionProps {
  description: string;
}

export const BomPageExplainerSectionDescription: FC<
  BomPageExplainerSectionDescriptionProps
> = ({ description }) => {
  return (
    <div className="font-normal text-gray-700 text-xxs">
      <T keyName={description} />
    </div>
  );
};
